import React from 'react';
import {
  BarChart, Bar, LineChart, Line, PieChart, Pie, Cell,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const COLORS = ['#f97316','#3b82f6','#22c55e','#a855f7','#ec4899','#14b8a6','#f59e0b','#ef4444'];

export default function ResultChart({ chart, data }) {
  if (!chart || chart.type === 'none' || !data?.length) return null;

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null;
    return (
      <div style={s.tooltip}>
        {label && <p style={s.tooltipLabel}>{label}</p>}
        {payload.map((p, i) => (
          <p key={i} style={{ ...s.tooltipVal, color: p.color }}>
            {p.name}: <strong>{typeof p.value === 'number' ? p.value.toLocaleString() : p.value}</strong>
          </p>
        ))}
      </div>
    );
  };

  const common = {
    data, margin: { top: 8, right: 20, left: 0, bottom: 8 }
  };

  return (
    <div style={s.wrap}>
      <ResponsiveContainer width="100%" height={260}>
        {chart.type === 'bar' ? (
          <BarChart {...common}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
            <XAxis dataKey={chart.x} tick={{ fontSize: 11, fill: 'var(--text-muted)', fontFamily: 'var(--font-main)' }} />
            <YAxis tick={{ fontSize: 11, fill: 'var(--text-muted)', fontFamily: 'var(--font-main)' }} />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: 12, fontFamily: 'var(--font-main)' }} />
            <Bar dataKey={chart.y} fill="#f97316" radius={[4, 4, 0, 0]} />
          </BarChart>
        ) : chart.type === 'line' ? (
          <LineChart {...common}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
            <XAxis dataKey={chart.x} tick={{ fontSize: 11, fill: 'var(--text-muted)', fontFamily: 'var(--font-main)' }} />
            <YAxis tick={{ fontSize: 11, fill: 'var(--text-muted)', fontFamily: 'var(--font-main)' }} />
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Line type="monotone" dataKey={chart.y} stroke="#f97316" strokeWidth={2.5} dot={{ fill: '#f97316', r: 4 }} activeDot={{ r: 6 }} />
          </LineChart>
        ) : chart.type === 'pie' ? (
          <PieChart>
            <Pie
              data={data}
              dataKey={chart.y}
              nameKey={chart.x}
              cx="50%" cy="50%" outerRadius={100}
              label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
              labelLine={{ stroke: 'var(--text-muted)' }}
            >
              {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
          </PieChart>
        ) : null}
      </ResponsiveContainer>
    </div>
  );
}

const s = {
  wrap: {
    background: 'var(--bg-primary)', borderRadius: 12, padding: '16px 8px 8px',
    border: '1px solid var(--border-subtle)', marginBottom: 12,
    animation: 'fadeIn 0.4s ease',
  },
  tooltip: {
    background: 'var(--bg-secondary)', border: '1px solid var(--border-subtle)',
    borderRadius: 10, padding: '10px 14px', boxShadow: 'var(--shadow-md)',
  },
  tooltipLabel: { fontSize: 12, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 4 },
  tooltipVal: { fontSize: 12, color: 'var(--text-secondary)' },
};
